import { render, staticRenderFns } from "./DecidedOpportunities.vue?vue&type=template&id=ca9d8870&scoped=true&"
import script from "./DecidedOpportunities.vue?vue&type=script&lang=js&"
export * from "./DecidedOpportunities.vue?vue&type=script&lang=js&"
import style0 from "./DecidedOpportunities.vue?vue&type=style&index=0&id=ca9d8870&prod&lang=css&"
import style1 from "./DecidedOpportunities.vue?vue&type=style&index=1&id=ca9d8870&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca9d8870",
  null
  
)

export default component.exports